/**
 * 创建人：袁俊双
 * 时间：2019-6-11
 * 描述：将数字值转换成 权限的类型
 * 更新记录: 
 */
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'type'
})
export class TypePipe implements PipeTransform {
  //获取当前dom节点
  constructor(private dom: DomSanitizer){}
  /**
   * 管道的初始化方法
   * @param value 传入的数据 1:行权限 或者2:表达式权限  或3:列权限 
   */
  transform(value: boolean | number |any ): any {
    if(+value == 1){
      return this.dom.bypassSecurityTrustHtml(`<span class="state-waring">行权限</span>`);
    } else if(+value == 2)  {
      return this.dom.bypassSecurityTrustHtml(`<span class="state-info">表达式权限</span>`);
    } else if(+value == 3)  {
      return this.dom.bypassSecurityTrustHtml(`<span class="state-error">列权限</span>`);
    }
  }
}
